import { featureFlags } from "$global-providers/feature-flags-provider/feature-flags";
import { useFeatureFlag } from "$global-providers/feature-flags-provider/provider";

export const useBillingCodesEnabled = (): boolean => {
  const [enabled, { loading }] = useFeatureFlag(
    featureFlags.epocus.billingCodes,
  );
  return enabled === true && !loading;
};
